// Prefix

export const PREFIX_TEMPO = 'TEMPO_'
export const PREFIX_MEMSOURCE = 'MEMSOURCE_'
export const PREFIX_XTRF = 'XTRF_'

// Memsource roles

export const MEMSOURCE_LINGUIST = `${PREFIX_MEMSOURCE}LINGUIST`
export const MEMSOURCE_PROJECT_MANAGER = `${PREFIX_MEMSOURCE}PROJECT_MANAGER`
export const MEMSOURCE_ADMIN = `${PREFIX_MEMSOURCE}ADMIN`
export const MEMSOURCE_GUEST = `${PREFIX_MEMSOURCE}GUEST`
export const MEMSOURCE_SUBMITTER = `${PREFIX_MEMSOURCE}SUBMITTER`

// Tempo roles

export const TEMPO_TERMINOLOGY = `${PREFIX_TEMPO}Terminology`
export const TEMPO_REQUEST = `${PREFIX_TEMPO}Request`
export const TEMPO_PROJECT = `${PREFIX_TEMPO}Project`
export const TEMPO_SETTINGS = `${PREFIX_TEMPO}Settings`
export const TEMPO_VALIDATE = `${PREFIX_TEMPO}Validate`
export const TEMPO_VALIDATION_MANAGEMENT = `${PREFIX_TEMPO}ValidationManagement`
export const TEMPO_FORUM = `${PREFIX_TEMPO}Forum`
export const TEMPO_REPORTING = `${PREFIX_TEMPO}Reporting`
export const TEMPO_REPORTING_MANAGEMENT = `${PREFIX_TEMPO}ReportingManagement`
